import { Checkbox } from 'Components/designSystem';
import styled, { css } from 'styled-components';

export const offerPagePadding = css`
    padding-left: ${ ({ theme }) => theme.size.size_30 };
    padding-right: ${ ({ theme }) => theme.size.size_30 };

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
        padding-left: ${ ({ theme }) => theme.size.size_20 };
        padding-right: ${ ({ theme }) => theme.size.size_20 };
    }
`;

export const SelectAllCheckbox = styled(Checkbox)`
    display: flex;
    align-items: center;
    align-self: flex-start;
    padding: ${ ({ theme }) => `${ theme.size.size_20 } ${ theme.size.size_10 }` };
`;
